interface CircularProgressProps {
  radius?: number
  percent: number
  linearGradient: [string, string]
  round: boolean
  colorCircle: string
  className?: string
  gradientId?: string
}

export const CircularProgress = ({
  radius = 12,
  percent,
  linearGradient,
  round,
  colorCircle,
  className,
  gradientId = "grad1",
}: CircularProgressProps) => {
  const stroke = 3
  const normalizedRadius = radius - stroke * 0.5
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (percent / 100) * circumference

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      className={className}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1='0%'
          y1='0%'
          x2='100%'
          y2='0%'
        >
          <stop
            offset='0%'
            style={{ stopColor: linearGradient[0], stopOpacity: 1 }}
          />
          <stop
            offset='100%'
            style={{ stopColor: linearGradient[1], stopOpacity: 1 }}
          />
        </linearGradient>
      </defs>
      <circle
        className='tw-origin-center tw-rotate-[-90deg] tw-transform'
        stroke={colorCircle}
        fill='transparent'
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        className='tw-origin-center tw-rotate-[-90deg] tw-transform'
        stroke={`url(#${gradientId})`}
        fill='transparent'
        strokeWidth={stroke}
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap={round ? "round" : "butt"}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  )
}
